<!--
 * @Author: cryi.liu
 * @Date: 2020-05-08 10:16:49
 * @LastEditTime: 2020-06-20 13:51:24
 * @Description: 题目选项
 -->
<template>
  <div class="question-options">
    <p class="title">
      <span>选项</span>
      <i-button v-if="showCorrectBtn" size="small" @click="showCorrectAnswerModal">修正答案</i-button>
    </p>
    <div v-for="(option, index) in options" :key="option.id" class="item">
      <div>
        <i-input
          ref="option-input"
          :value="option.content"
          :readonly="readonlys[index]"
          @on-change="optionInputChangedHandler(index, $event)">
            <div slot="prefix">
              <i-icon
                :type="option.correct ? 'md-checkmark' : 'md-close'"
                :style="{ color: option.correct ? 'green' : 'red' }"
              />
              <span>{{ optionsEnum[index] }}、</span>
            </div>
            <div slot="suffix" class="btn-group" :class="showDeleteOptionBtn ? 'two' : 'one'">
              <i-button
                :type="btnTypes[index]"
                @click="canEditOrSaveQuestionOptionHandler(index)">{{ btnTexts[index] }}</i-button>
              <i-button
                v-if="showDeleteOptionBtn"
                class="delete-btn"
                type="error" @click="deleteOptionHandler(option)">删除</i-button>
            </div>
        </i-input>
        <upload-media-file
          v-if="
            mediaType &&
            (questionType === '单选' ||
              questionType === '判断' ||
              questionType === '多选' ||
              questionType === '不定项选择')"
          control="option"
          :library-id="libraryId"
          :option-id="option.id" @repull-question-info="repullQuestionInfo" />
      </div>
      <p v-if="option.mediaPath" class="media-path">
        <span>媒体预览：</span>
        <a
          href="javascript:void(0)"
          @click="previewMedia(option)">{{ option.mediaPath }}</a>
        <i-icon class="icon-delete" type="md-trash" @click="deleteMediaFile(option.id)" />
      </p>
    </div>
    <i-button
      v-if="showAddOptionBtn"
      class="add-option"
      type="primary"
      icon="md-add"
      size="small"
      @click="addOptionHandler"
      >新增选项</i-button>
    <correct-answer-modal
      :library-id="libraryId"
      :question-type="questionType"
      :modal-show="modalShow"
      :options="options"
      @hide-modal="hideCorrectAnswerModal" @repull-question-info="repullQuestionInfo" />
    <add-option-modal
      :library-id="libraryId"
      :options="options"
      :modal-show="addOptionModalShow"
      @hide-modal="hideAddOptionModal" @repull-question-info="repullQuestionInfo" />
  </div>
</template>

<script>
import UploadMediaFile from './UploadMediaFile.vue';
import CorrectAnswerModal from './CorrectAnswerModal.vue';
import AddOptionModal from './AddOptionModal.vue';

const optionsEnum = ['A', 'B', 'C', 'D', 'E', 'F'];

export default {
  name: 'QuestionOption',
  components: {
    UploadMediaFile,
    CorrectAnswerModal,
    AddOptionModal,
  },
  props: {
    questionType: { type: String, required: true },
    libraryId: { type: String, reuqired: true },
    options: { type: Array, require: true },
    mediaType: { type: Boolean, required: true },
  },
  data() {
    return {
      tempOption: [],
      readonlys: [],
      btnTexts: [],
      btnTypes: [],
      modalShow: false,
      addOptionModalShow: false,
      optionsEnum,
    };
  },
  computed: {
    showCorrectBtn() {
      return !(this.questionType === '填空' || this.questionType === '简答');
    },
    showAddOptionBtn() {
      return this.questionType === '单选' || this.questionType === '多选' || this.questionType === '不定项选择';
    },
    showDeleteOptionBtn() {
      return this.questionType === '单选' || this.questionType === '多选' || this.questionType === '不定项选择';
    },
  },
  watch: {
    options: {
      immediate: true,
      handler(options) {
        const len = options.length;

        this.readonlys = new Array(len).fill(true);
        this.btnTexts = new Array(len).fill('修改');
        this.btnTypes = new Array(len).fill('primary');

        options.forEach((option) => {
          this.tempOption.push(option.content);
        });
      },
    },
  },
  methods: {
    /**
     * 启用修改或者保存题目选项内容信息
     */
    canEditOrSaveQuestionOptionHandler(index) {
      if (this.readonlys[index]) {
        this.$set(this.readonlys, index, false);
        this.$set(this.btnTexts, index, '保存');
        this.$set(this.btnTypes, index, 'success');

        (this.$refs['option-input'][index]).focus();
      } else {
        this.saveQuestionOptionHandler(index);
      }

      this.$emit('set-options-edit-flag', { index, flag: !this.readonlys[index] });
    },
    /**
     * 保存题目选项内容处理函数
     */
    saveQuestionOptionHandler(index) {
      if (this.tempOption[index] === this.options[index].content) {
        this.$set(this.readonlys, index, true);
        this.$set(this.btnTexts, index, '修改');
        this.$set(this.btnTypes, index, 'primary');

        return;
      }

      if (!this.mediaType) {
        if (this.tempOption[index] === '') {
          alert('选项内容不能为空');
          return;
        }
      }

      this.requestSaveQuestionInfoAndSetting(index);
    },
    /**
     * 选项输入框内容改变处理函数
     */
    optionInputChangedHandler(index, e) {
      this.tempOption[index] = e.target.value;
    },
    /**
     * 媒体文件预览
     */
    previewMedia({ mediaInfoVO: { mediaPath, mediaPath: realMediaPath, videoCover } }) {
      this.$emit('preview-media', { mediaPath, realMediaPath, videoCover });
    },
    /**
     * 添加多选题选项处理函数
     */
    addOptionHandler() {
      const tempOption = JSON.parse(JSON.stringify(this.options));

      if (tempOption.length >= 6) {
        alert('最多包含6个选项！');
        // eslint-disable-next-line no-useless-return
        return;
      }

      this.addOptionModalShow = true;
    },
    /**
     * 删除多选题选项处理函数
     */
    deleteOptionHandler({ id }) {
      if (this.options.length <= 2) {
        alert(`${this.questionType}题最少包含2个选项！`);
        return;
      }

      if (window.confirm('确认删除选项？')) {
        this.requestDeleteOptionAndSetting(id);
      }
    },
    /**
     * 关闭添加选项模态框
     */
    hideAddOptionModal() {
      this.addOptionModalShow = false;
    },
    /**
     * 显示修正答案浮层
     */
    showCorrectAnswerModal() {
      this.modalShow = true;
    },
    /**
     * 隐藏修正答案浮层
     */
    hideCorrectAnswerModal() {
      this.modalShow = false;
    },
    /**
     * 重新请求题目信息
     */
    repullQuestionInfo() {
      this.$emit('repull-question-info');
    },
    /**
     * 删除多媒体文件
     */
    deleteMediaFile(optionId) {
      if (window.confirm('确认删除多媒体文件？')) {
        this.requestDeleteStemMediaFile(optionId)
          .then(() => {
            alert('删除多媒体文件成功');

            this.repullQuestionInfo();
          })
          .catch((result) => {
            alert(result.msg);
          });
      }
    },
    /**
     * 请求删除题干多媒体文件
     */
    requestDeleteStemMediaFile(optionId) {
      const params = {
        id: this.libraryId,
        options: [
          {
            id: optionId,
            mediaPath: '',
          },
        ],
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.librarySaveQuestion(params);

        if (result.code === '200') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 请求保存题库题目选项信息并设置
     */
    requestSaveQuestionInfoAndSetting(index) {
      this.requestSaveQuestionInfo(index)
        .then(() => {
          alert('选项内容保存成功！');

          const options = JSON.parse(JSON.stringify(this.options));
          options[index].content = this.tempOption[index];

          this.$set(this.readonlys, index, true);
          this.$set(this.btnTexts, index, '修改');
          this.$set(this.btnTypes, index, 'primary');

          this.$emit('set-options', options);
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求保存题库题目选项信息
     */
    requestSaveQuestionInfo(index) {
      const option = this.options[index];
      option.content = this.tempOption[index];

      const params = {
        id: this.libraryId,
        options: [option],
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.librarySaveQuestion(params);

        if (result.code === '200') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 请求删除题库题目选项并设置
     */
    requestDeleteOptionAndSetting(optionId) {
      this.requestDeleteOption(optionId)
        .then(() => {
          alert('删除选项成功！');
          this.repullQuestionInfo();
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求删除题库题目选项
     */
    requestDeleteOption(optionId) {
      const params = {
        optionId,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.libraryDeleteOption(params);

        if (result.code === '200') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.question-options {
  margin-bottom: 16px;
  width: 100%;

  > .title {
    margin-bottom: 18px;
    font-size: 16px;
    font-weight: bold;

    > button {
      margin-left: 12px;
    }
  }

  > .item {
    margin-bottom: 12px;

    /deep/ .ivu-input-wrapper {
      .ivu-input-prefix {
        width: 58px;

        .ivu-icon {
          margin-right: 6px;
        }
      }

      .ivu-input-with-prefix {
        padding-left:58px;
      }

      .ivu-input-suffix {
        width: calc(58px * 2);
      }

      .btn-group {
        display: flex;
        justify-content: space-between;

        &.one {
          float: right;
          width: 50%;
        }
      }
    }

    &:last-of-type {
      margin-bottom: 0;
    }

    > div {
      display: flex;
      justify-content: flex-start;
      height: 36px;
    }

    > .media-path {
      padding: 6px 0;
      font-size: 12px;

      > span {
        font-weight: bold;
      }

      > a {
        text-decoration: underline;
      }

      > .icon-delete {
        margin-left: 12px;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }

  > .add-option {
    margin-top: 12px;
  }
}
</style>
